import Loader from '@/components/Loader';
import SubjectSelector from './SubjectSelector';
import TagTypes from '@/constants/TagTypes';
import useTags from '@/hooks/useTags';
import useUserTags from '@/hooks/useUserTags';
import { PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useUser } from '@lore/auth';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

export default function EditableSubjects(props) {
  const { showEditToggle = true } = props;
  const currentUser = useUser();
  const [isEditing, setIsEditing] = useState(false);
  const subjects = useTags(TagTypes.Subject);
  const userSubjects = useUserTags(currentUser, TagTypes.Subject);

  if (!currentUser || subjects.state === 'FETCHING' || userSubjects.state === 'FETCHING') {
    return <Loader />;
  }

  const titleText = 'What subject areas do you teach?';

  if (!showEditToggle) {
    return (
      <div>
        <SubjectSelector user={currentUser} subjects={subjects} userSubjects={userSubjects} defaultOpen={false} />
      </div>
    );
  }

  return (
    <div>
      <div className="mb-2 flex items-center space-x-3">
        <h4 className="text-base font-semibold text-cs-gray-900">{titleText}</h4>
        <button
          type="button"
          className="text-cs-blue-500 hover:opacity-60"
          onClick={() => setIsEditing(!isEditing)}
          aria-label={isEditing ? 'Close edit subject areas' : 'Edit subject areas'}
        >
          {isEditing ? (
            <XMarkIcon className="size-5" />
          ) : (
            <PencilSquareIcon className="size-5" />
          )}
        </button>
      </div>
      {isEditing ? (
        <div className="p-4">
          <SubjectSelector user={currentUser} subjects={subjects} userSubjects={userSubjects} />
        </div>
      ) : (
        <div className="space-y-1 text-base text-cs-gray-500">
          {userSubjects.data.length > 0 ? (
            userSubjects.data.map((us) => (
              <div key={us.id}>
                <div>{us.data.name}</div>
                <div className="text-xs pl-4">{us._tagNode.data.description}</div>
              </div>
            ))
          ) : (
            <p className="italic text-cs-gray-400">No subject areas selected.</p>
          )}
        </div>
      )}
    </div>
  );
}

EditableSubjects.propTypes = {
  showEditToggle: PropTypes.bool,
};
